import React from 'react'
import { FormattedMessage } from 'react-intl'

import Image from '@components/Image'
import Container from '@components/Container'

import { Logo, Slogan } from '@assets/logos'

import * as Style from './Footer.style'

export default function Footer() {
  return (
    <Style.FooterWrapper>
      <Container>
        <Style.FooterContent>
          <Style.LogoWrapper>
            <Image src={Logo} alt="Gympass escrito em laranja" />
            <Image
              src={Slogan}
              alt='Slogan do Gympass escrito em laranja "helping people find an activity to love"'
            />
          </Style.LogoWrapper>

          <Style.TextTiny>
            &copy; 2012-{new Date().getFullYear()}{' '}
            <FormattedMessage id="smb_acquisition_company_info.footer.copyright" />
          </Style.TextTiny>
        </Style.FooterContent>
      </Container>
    </Style.FooterWrapper>
  )
}
